import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { sprintf } from 'sprintf-js';

import { environment } from '../../environments/environment';
import { File } from '../_models';
import { BaseService } from './base.service';

@Injectable()
export class FileService extends BaseService {

  constructor(
    protected http: HttpClient,
  ) {
    super(http, `${environment.apiBaseUrl}/companies/%(company_id)s/files`);
  }
}

@Injectable()
export class GlobalFileService extends BaseService {

  constructor(
    protected http: HttpClient,
  ) {
    super(http, `${environment.apiBaseUrl}/files`);
  }
}